exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*This fixes the arrow not changing color*/\n.has-text-white.navbar-link[data-v-12fd909c]::after {\n  border-color: white;\n}\n.nav-background-fix[data-v-12fd909c] {\n  border-radius: 1.5rem;\n}\n.nav-background-fix > .navbar-item[data-v-12fd909c] {\n  border-radius: 1.5rem;\n}\n.nav-background-fix .has-dropdown .navbar-link[data-v-12fd909c] {\n  border-radius: 1.5rem;\n}\n.nav-background-fix .has-dropdown .navbar-dropdown[data-v-12fd909c] {\n  border-radius: 6px;\n}", ""]);

// exports
